import { createTheme } from '@mui/material/styles'
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  BACKGROUND_COLOR,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  PAPER_COLOR,
} from './palette'

const theme = createTheme({
  palette: {
    primary: { main: PRIMARY_COLOR },
    secondary: { main: SECONDARY_COLOR },
    background: {
      default: BACKGROUND_COLOR,
      paper: PAPER_COLOR,
    },
    text: {
      primary: TEXT_PRIMARY,
      secondary: TEXT_SECONDARY,
    },
  },
  typography: {
    fontFamily: 'Inter, Roboto, sans-serif',
  },
})

export default theme
